/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/
import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {environment} from '../../../../environments/environment';
import {Observable} from 'rxjs';
import {PartnerBaseModel} from '../contracts/partner-base.model';
import {Cacheable} from '../../../decorators/cacheable.decorator';
import {GroupTypeEnum} from '../contracts/group-type.enum';
import {EntityGroupDetailContract} from '../contracts/entity-group/entity-group-detail.contract';
import {RoleDetailContract} from '../contracts/role-detail.contract';
import {EntityGroupTypeDetailContract} from '../contracts/entity-group/entity-group-type-detail.contract';

@Injectable({
    providedIn: 'root'
})
export class ReferenceDataService {
    // API endpoint
    public partnerDetailActiveUrl = `${environment.securityBaseUrl}/api/partner/detail/active`;
    public roleUrl = `${environment.securityBaseUrl}/api/role`;
    public entityGroupUrl = `${environment.securityBaseUrl}/api/entityGroup`;
    public entityGroupTypeUrl = `${environment.securityBaseUrl}/api/entityGroupType`;

    constructor(protected http: HttpClient) {
    }

    /**
     * @deprecated use getEntityGroupTypeDetail('PARTNER', true, ...)
     */
    @Cacheable()
    getActivePartners(): Observable<PartnerBaseModel[]> {
        return this.http.get<PartnerBaseModel[]>(this.partnerDetailActiveUrl);
    }

    @Cacheable()
    getRoles(context: string): Observable<RoleDetailContract[]> {
        return this.http.get<RoleDetailContract[]>(`${this.roleUrl}/context/${context}`);
    }

    @Cacheable()
    getEntityGroupTypeDetail(groupType: GroupTypeEnum, context: string, active?: boolean):
            Observable<EntityGroupDetailContract[]> {
        return this.http.post<EntityGroupDetailContract[]>(`${this.entityGroupUrl}/groupType/${groupType}/detail`,
                {
                    searchCriteria: {
                        active: active,
                        context: context
                    }
                }
        );
    }

    @Cacheable()
    getEntityContextDetail(context: string):
            Observable<EntityGroupTypeDetailContract[]> {
        return this.http.get<EntityGroupTypeDetailContract[]>(`${this.entityGroupTypeUrl}/context/${context}/detail`);
    }
}
